module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"add_favorits":"Ajouter aux favoris","remove_favorits":"Dans vos favoris"},"en":{"add_favorits":"Add to favorits","remove_favorits":"In your favorits"}}')
  delete Component.options._Ctor
}
